import React, {useEffect, useState} from "react";
import {auth} from "../../../store/auth.store";
import {useNavigate, useParams} from "react-router-dom";
import {ApiService} from "lib/http.service";
import {env} from "../../../constants/global.vars";
import _ from "lodash";
import {gtmSelectItem, gtmViewItemList} from "../../../services/misc.functions";
import paths from "../../../paths";
import iconRight from "../../../assets/feather/arrow-right.svg";

const AltenarGamePlayer = ({slug}: {slug:string}) => {
    const userToken = auth.token;
    const queryParams = new URLSearchParams({
        slug: slug || '',
        userToken: userToken || '',
        isTest: window.location.origin.includes('test') || window.location.origin.includes('localhost') ? "true" : "false",
    });

    const widgetUrl = `${window.location.origin}/altenar-wsdk/altenar-wsdk.html?${queryParams.toString()}`;

    return (
        <div className="page-widget numeric-game-page p-3" style={{minHeight: '80vh', height: '100%'}}>
            <iframe
                title='Altenar Sportsbook'
                style={{width: '100%', height: '50dvh', border: 'none', minHeight: '80dvh', zIndex:99999, position:"absolute"}}
                allow="fullscreen; autoplay"
                src={widgetUrl}
            />
        </div>
    );
};

export default function AltenarGames() {
    const params = useParams();
    const activeSlug = params.subpage;
    const navigate = useNavigate();
    const [gamesList, setGamesList] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getGames = async () => {
            let games;
            if (!games) {
                const res: any = await new ApiService().start("post", env.accounting_api + "/games/api/list-game/", {
                    vendor: 10
                }, false);
                if (res && res.status) {
                    games = _.orderBy(res.data, ["ordering"], "asc");
                }
            }
            const filtered = (games || []).filter((g: any) => g.vendor === 10);
            setGamesList(filtered);
            gtmViewItemList(filtered, "Oyun");
            setLoading(false);
        };
        getGames();
    }, []);

    if (activeSlug) {
        return <AltenarGamePlayer slug={activeSlug}/>;
    }

    return (
        <div className="page-widget">
            <svg style={{display: "none"}}>
                <defs>
                    <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
                </defs>
            </svg>
            <div className={"tab-scroll"}>
                {/* Tab Header */}
                <ul className="nav nav-tabs">
                    <li
                        key={`tabs`}
                        className={`nav-item active`}
                    >
                        <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                        <a className="nav-link" id={`011`}>
                            Sanal At Yarışı
                        </a>
                        <svg className="right" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                    </li>
                </ul>
            </div>

            {loading ? (
                <div className="text-white px-4">Oyunlar yükleniyor...</div>
            ) : (
                <div className="row m-2">
                    {gamesList.map((game: any, key: number) => {
                        const isRemanded = game.is_active === false && auth.member?.id && auth.remaining_games.includes(game.id);
                        const statusClass = game.is_active ? "playable" : (isRemanded ? "remanded" : "");

                        return (
                            <div key={`games-list-${key}`} className="col-6 col-lg-3 mb-4">
                                <div className="game-widget">
                                    <img
                                        className="games pointer"
                                        src={`${env.cdn_host}/media/${game.image}`}
                                        style={{objectFit: 'fill'}}
                                        alt={game.name}
                                        onClick={() => {
                                            if (game.is_active) {
                                                navigate(`${paths.vrhorseracing.url}/${game.code}`);
                                                gtmSelectItem([game], "Oyunlar");
                                            }
                                        }}
                                    />

                                    <div className={`${statusClass} body mt-2`}>
                                        {game.is_active ? (
                                            <>
                                                <span
                                                    className="label text-decoration-none text-black pointer"
                                                    onClick={() => {
                                                        navigate(`${paths.vrhorseracing.url}/${game.code}`);
                                                        gtmSelectItem([game], "Oyunlar");
                                                    }}
                                                >
                                                    Hemen Oyna
                                                </span>
                                            </>
                                        ) : (
                                            <span className="label pointer">
                                                {isRemanded ? "✅ Hatırlatıcı kuruldu" : "⏰ Hatırlat"}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
